var map = {
	"./01-_DSC0801.jpg": 61,
	"./02-_DSC0830.jpg": 62,
	"./04-_DSC0914.jpg": 63,
	"./5-_DSC0814.jpg": 64,
	"./6-_DSC7708.jpg": 65,
	"./7-_DSC6395.jpg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;